const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/subscriptions/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/subscriptions/")({
  beforeLoad: args => requirePermission(Permissions.Subscriptions.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
export function StatusBadge({
  status
}: {
  status: SubscriptionStatus;
}) {
  const colors: Record<SubscriptionStatus, string> = {
    Trialing: "bg-blue-100 text-blue-700",
    Active: "bg-green-100 text-green-700",
    PastDue: "bg-amber-100 text-amber-700",
    Grace: "bg-orange-100 text-orange-700",
    Canceled: "bg-gray-200 text-gray-700",
    Expired: "bg-red-100 text-red-700",
    Paused: "bg-purple-100 text-purple-700"
  };
  return <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${colors[status]}`}>
      {status}
    </span>;
}